import {AppRoute} from '../../../../models/AppRoute';
import {AccountScreenAction} from '../../../../models/navigationTypes';

export const createMockNavigation = () => ({
  navigate: (route: string, params?: any) => {
    // eslint-disable-next-line no-console
    console.log('[Storybook] Navigate to:', route, params);
  },
  // eslint-disable-next-line no-console
  goBack: () => console.log('[Storybook] Go back'),
  setOptions: () => {},
  addListener: () => () => {},
  removeListener: () => {},
  dispatch: () => {},
  reset: () => {},
  isFocused: () => true,
  canGoBack: () => false,
  getId: () => 'mock-id',
  getParent: () => undefined,
  getState: () => ({}) as any,
});

export const createMockRoute = (action: AccountScreenAction, email?: string) => ({
  key: 'account-create-mock',
  name: AppRoute.ACCOUNT_CREATE,
  params: {
    action,
    email,
  },
  path: undefined,
});
